import { graphql } from '../__generated__/gql';

export const GET_READINESS_METRICS_BY_EVENT = graphql(/* GraphQL */ `
  query ReadinessMetrics($eventId: Int!) {
    readinessMetricsByEventId(eventId: $eventId) {
      metricId
      eventId
      readinessPerc
      updatedAt
    }
  }
`);

export const CREATE_READINESS_METRIC = graphql(/* GraphQL */ `
  mutation Mutation($input: ReadinessMetricInput!) {
    createReadinessMetric(input: $input) {
      metricId
      eventId
      updatedAt
      readinessPerc
    }
  }
`);
